import { WINDOW_SIZE, NAVBAR_SIZE } from './size';
import { Platform } from 'react-native';
export const WEB_SCROLLVIEW_STYLE = {
  height: `${WINDOW_SIZE.height - NAVBAR_SIZE.height}px`,
};

export const IS_WEB = Platform.OS === 'web';
